import {
  getAll,
  save,
  update,
  deleteById,
} from "@/services/salles/CategoryService.js";
import i18n from "@/i18n";

const state = {
  categories: [],
};

const getters = {
  getCategories(state) {
    return state.categories;
  },
  getCategoryById: (state) => (id) => {
    return state.categories.find((x) => x.id === id);
  },
};

const mutations = {
  SET_CATEGORIES: (state, data) => (state.categories = data),
  ADD_CATEGORY: (state, payload) => state.categories.push(payload),
  EDIT_CATEGORY: (state, payload) => {
    let index = state.categories.findIndex((l) => l.id === payload.id);
    if (index !== -1) state.categories.splice(index, 1, payload);
  },
  REMOVE_CATEGORY: (state, payload) => {
    let index = state.categories.findIndex((l) => l.id === payload);
    if (index !== -1) state.categories.splice(index, 1);
  },
};

const actions = {
  /**
   * This method will load all categories from the database
   * 
   * @param  {vueX} {commit necessary if call commit inside the method
   * @param  {vueX} dispatch} necessary if call dispatch inside the method
   * @returns {} it is returning nothing because the response will be load in the store directly => commit("SET_CATEGORIES", response.data)
   */
  async loadCategories({ commit, dispatch }) {
    await getAll()
      .then((response) => commit("SET_CATEGORIES", response.data))
      .catch((error) => {
        dispatch(
          "notificationModule/showNotification",
          {
            messageAlert: i18n.t("messageStores.categoryAllError"),
            typeAlert: "error",
          },
          { root: true }
        );
      });
  },
  /**
   * This method is calling the http call to add a category in the database and then in the VueX store
   * 
   * @param  {vueX} {commit necessary if call commit inside the method
   * @param  {vueX} dispatch} necessary if call dispatch inside the method
   * @param  {Object - categoryDto} category object that we want to add in the database
   * @returns {} it is returning nothing because the response will be load in the store directly => commit("ADD_NEW_CATEGORY", response.data)
   */
  async addCategory({ commit, dispatch }, category) {
    await save(category)
      .then((response) => {
        commit("ADD_CATEGORY", response.data);
        dispatch(
          "notificationModule/showNotification",
          {
            messageAlert: i18n.t("messageStores.categoryAddSuccess"),
            typeAlert: "success",
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch(
          "notificationModule/showNotification",
          {
            messageAlert: i18n.t("messageStores.categoryAddError"),
            typeAlert: "error",
          },
          { root: true }
        );
      });
  },
  /**
   * This method is calling the http call to edit a category in the database and then in the VueX store
   * 
   * @param  {vueX} {commit necessary if call commit inside the method
   * @param  {vueX} dispatch} necessary if call dispatch inside the method
   * @param  {Object - categoryDto} category object that we want to edit in the database
   * @returns {} it is returning nothing because the response will be load in the store directly => commit("EDIT_CATEGORY", response.data)
   */
  async editCategory({ commit, dispatch }, category) {
    await update(category)
      .then((response) => {
        commit("EDIT_CATEGORY", response.data),
          dispatch(
            "notificationModule/showNotification",
            {
              messageAlert: i18n.t("messageStores.categoryEditSuccess"),
              typeAlert: "success",
            },
            { root: true }
          );
      })
      .catch((error) => {
        dispatch(
          "notificationModule/showNotification",
          {
            messageAlert: i18n.t("messageStores.categoryEditError"),
            typeAlert: "error",
          },
          { root: true }
        );
      });
  },
  /**
   * This method is calling the http call to delete a category in the database and then in the VueX store
   * 
   * @param  {vueX} {commit necessary if call commit inside the method
   * @param  {vueX} dispatch} necessary if call dispatch inside the method
   * @param  {Object - categoryDto} category object that we want to delete in the database
   * @returns {} it is returning nothing because the response will be load in the store directly => commit("REMOVE_CATEGORY", category.id)
   */
  async deleteCategory({ commit, dispatch }, category) {
    await deleteById(category.id)
      .then((response) => {
        if (response.status === 202) {
          commit("REMOVE_CATEGORY", category.id),
            dispatch(
              "notificationModule/showNotification",
              {
                messageAlert: i18n.t("messageStores.categoryDeleteSuccess"),
                typeAlert: "success",
              },
              { root: true }
            );
        }
      })
      .catch((error) => {
        dispatch(
          "notificationModule/showNotification",
          {
            messageAlert: i18n.t("messageStores.categoryDeleteError"),
            typeAlert: "error",
          },
          { root: true }
        );
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

